module.exports = __webpack_public_path__ + "assets/online-pay.2705862b.svg";